import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { ClientAvatarComponent } from '@components/client-avatar/client-avatar.component';
import { ExcludeMyselfPipe } from '@helpers/pipes/exclude-myself.pipe';
import { MessagesService } from '@pages/messages/messages.service';
import { HasUnreadMessagesPipe } from '@pages/messages/pipes/has-unread-messages.pipe';
import { ThreadTitlePipe } from '@pages/messages/pipes/thread-title.pipe';
import { MessagesThreadListItemComponent } from '../thread-list-item/thread-list-item.component';
import { Thread } from '@appbolaget/aware-model';
import { MESSAGES_ROUTE } from '@pages/messages/symbols';
import { Config } from '@services/config';
import { IMessagesConfig } from '@pages/messages/messages.config';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { AsyncPipe, NgFor } from '@angular/common';

@Component({
    selector: 'app-messages-thread-list',
    templateUrl: 'thread-list.component.html',
    standalone: true,
    imports: [
        ThreadTitlePipe,
        HasUnreadMessagesPipe,
        ClientAvatarComponent,
        ExcludeMyselfPipe,
        MessagesThreadListItemComponent,
        MatListModule,
        RouterLink,
        RouterLinkActive,
        AsyncPipe,
        NgFor,
    ],
    styles: [
        `
            .mat-mdc-list-item {
                height: auto !important;
                &.mdc-list-item--activated {
                    &::after {
                        content: '';
                        display: block;
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 4px;
                        height: 100%;
                        background-color: var(--color-primary);
                    }
                }
            }
        `,
    ],
})
export class MessagesThreadListComponent implements OnInit {
    #messagesService = inject(MessagesService);
    #config = inject(Config);
    #router = inject(Router);
    threads$ = this.#messagesService.threads$;

    @Input() isInDialog = false;
    @Output() onThreadClick = new EventEmitter<Thread>();

    openThreadInDialog: boolean;

    messagesRoute = MESSAGES_ROUTE.join('/');

    ngOnInit() {
        this.openThreadInDialog =
            this.#config.get<IMessagesConfig['topbar']['openThreadInDialog']>('messages.topbar.openThreadInDialog') &&
            this.isInDialog &&
            !this.#router.url.includes(MESSAGES_ROUTE.join('/'));
    }

    async threadClick(e: MouseEvent, thread: Thread): Promise<void> {
        if (this.openThreadInDialog) {
            e.preventDefault();
            e.stopPropagation();

            this.onThreadClick.next(thread);
        }
    }

    trackByThread(_: number, thread: Thread) {
        return thread.uuid;
    }
}
